//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "workFlow",
  data() {
    return {
      src: '',
      myBtnDiv : document.getElementById("myBtn")
    }
  },
  methods: {
    // 获取路径
    resetSrc: function (url) {
      this.src = url;
    },
    backLastPage() {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.resetSrc(this.$store.state.iframeUrl);
    this.myBtnDiv && (this.myBtnDiv.style.display = "none")
  },
  destroyed() {
    this.myBtnDiv && (this.myBtnDiv.style.display = "block")
  },
  watch: {}
}



// WEBPACK FOOTER //
// ./src/page/flow/dynamic-flow.vue